import React from "react";
import { UserOutlined, CheckCircleOutlined, ExclamationCircleOutlined, ClockCircleOutlined } from "@ant-design/icons";

// 定义统计卡片配置接口
interface StatisticCardConfig {
  key: string;
  title: string;
  value: number | string;
  prefix?: React.ReactNode; // 恢复为ReactNode类型
  suffix?: string;
  valueStyle?: React.CSSProperties;
  precision?: number;
  formatter?: (value: number | string, config?: any) => React.ReactNode;
  cardProps?: any;
  statisticProps?: any;
}

// 管理员统计配置
export const adminStatisticConfig: StatisticCardConfig[] = [
  {
    key: "total",
    title: "总管理员数",
    value: 0,
    prefix: <UserOutlined />, // 使用JSX元素
    valueStyle: { color: "#1890ff" },
  },
  {
    key: "active",
    title: "启用管理员",
    value: 0,
    prefix: <CheckCircleOutlined />,
    valueStyle: { color: "#52c41a" },
  },
  {
    key: "inactive",
    title: "禁用管理员",
    value: 0,
    prefix: <ExclamationCircleOutlined />,
    valueStyle: { color: "#ff4d4f" },
  },
];

// 根据数据生成统计配置
export const generateAdminStatistics = (stats: any) => {
  return adminStatisticConfig.map((config) => ({
    ...config,
    value: stats[config.key] || 0,
  }));
};

// 统计卡片组件配置
export const statisticConfig = {
  columns: 3,
  gutter: [16, 0] as [number, number], // 垂直间距设为0，由父容器的gap控制
};
